import { getAuth } from "firebase/auth";
import { getApiUrl } from "./config";

const base = () => getApiUrl();

/** GET /api/maintenance/draft-actions: list Leo draft actions for the landlord (optionally ?ticketId=). */
export async function getDraftActions(ticketId = null) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const url = ticketId
    ? `${base()}/maintenance/draft-actions?ticketId=${encodeURIComponent(
        ticketId
      )}`
    : `${base()}/maintenance/draft-actions`;
  const res = await fetch(url, {
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err.error || `Failed to load draft actions (${res.status})`
    );
  }
  const data = await res.json();
  return data.draftActions || [];
}

/** POST /api/maintenance/draft-actions/:id/approve: approve and send drafted vendor message. */
export async function approveDraftAction(draftActionId) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const res = await fetch(
    `${base()}/maintenance/draft-actions/${encodeURIComponent(
      draftActionId
    )}/approve`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to approve (${res.status})`);
  }
  return res.json();
}

/** GET /api/maintenance/decision-points-count: count and hours saved for Cognitive Load widget. */
export async function getDecisionPointsCount() {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const res = await fetch(`${base()}/maintenance/decision-points-count`, {
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to get count (${res.status})`);
  }
  const data = await res.json();
  return { count: data.count ?? 0, hoursSaved: data.hoursSaved ?? 0 };
}

/**
 * POST /api/maintenance/one-click-vendor-bids
 * Creates or reuses a maintenance ticket and invites up to 3 plumbing vendors (or demo vendors).
 * @param {{ tenantId: string, conversationId?: string, demo?: boolean }} body
 */
export async function postOneClickVendorBids(body) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const q = body?.demo ? "?demo=true" : "";
  const res = await fetch(
    `${base()}/maintenance/one-click-vendor-bids${q}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({
        tenantId: body.tenantId,
        ...(body.conversationId && { conversationId: body.conversationId }),
        ...(body.demo && { demo: true }),
      }),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data.error || `Failed to request vendor bids (${res.status})`
    );
  }
  return data;
}
